module.exports = __webpack_public_path__ + "img/accesspark.a68e5f94.svg";